<template>
  <div class="managingPeople hp100 bbox " v-loading="loading">
    <!-- 卡片视图 -->
    <el-card>
      <!-- 搜索-->
      <el-row :gutter="20" type="flex">
        <!-- <el-col> -->
        <!-- <div class="flex align-center justify-start header-search-box" > -->
        <el-input
          v-model="searchInput"
          placeholder="挂账人名称"
          clearable
          class="header-search-input ml10 header-search-box"
          style="width:220px;"
        ></el-input>
        <el-date-picker
          v-model="dateRange"
          value-format="yyyy-MM-dd"
          type="daterange"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          placeholder=""
          class="ml10"
        ></el-date-picker>
        <!-- </div> -->
        <!-- </el-col> -->
        <!-- <el-col> -->
        <el-button type="primary" class="ml10" @click="search()"
          >搜索</el-button
        >
        <!-- <el-button type="primary" @click="repaySearch('repay')">还款</el-button>
        <el-button type="primary" @click="repaySearch('consume')"
          >消费</el-button > -->
        <el-button type="primary" @click="exportXls()">导出</el-button>
        <!-- </el-col> -->

        <!-- <el-col>
          <el-button
            plain
            class="add-column-btn bbox"
            @click="gotoDetail('')"
            type="primary"
          >
            <i class="el-icon-plus fw900 f16"></i> 新增</el-button
          >
        </el-col> -->
        <!-- <el-col>
          <div class="flex align-center justify-start header-search-box">
            <el-input
              placeholder="查询条件"
              clearable
              v-model="searchInput"
              class="header-search-input ml10"
            >
              <el-button
                slot="append"
                icon="el-icon-search"
                class="textblue searchBtn"
                @click="search()"
              ></el-button>
            </el-input>
          </div>
        </el-col> -->
      </el-row>

      <el-row :gutter="20" type="flex" justify="center" class="row">
        <el-col style="display: flex; justify-content: center;">
          <el-button type="primary" class="button"
            >挂账金额: {{ charge || 0 }}</el-button
          >
          <el-button
            type="primary"
            class="button"
            style="background-color: #009688;"
            >减免金额: {{ reductionAmount }}</el-button
          >
          <el-button
            type="primary"
            class="button"
            style="background-color: #FFB800;"
            >剩余挂账金额: {{ remaing }}</el-button
          >
        </el-col>
        <!-- <el-col :span="8" style="display: flex; justify-content: center;">
        </el-col>
        <el-col :span="8" style="display: flex; justify-content: flex-start;">
        </el-col> -->
      </el-row>
      <!-- 用户列表区域 -->
      <div :style="{ height: height + 'px' }" style=" margin-top: 20px;">
        <el-scrollbar style="height: 100%; width: 100%">
          <el-row style="width: 100%">
            <el-table
              :data="tableData"
              border
              fit
              highlight-current-row
              style="width: 100%"
              @sort-change="sortChange"
            >
              <!-- <el-table-column label="" align="center"  prop="" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.id }}</span>
                        </template>
                    </el-table-column> -->
              <!-- <el-table-column type="selection" width="55" align="center">
              </el-table-column> -->
              <el-table-column
                label="挂帐人名称"
                align="center"
                prop="挂帐人名称"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.chargeMemberName }}</span>
                </template>
              </el-table-column>
              <el-table-column label="交易金额" align="center" prop="交易金额">
                <template slot-scope="scope">
                  <span>{{ scope.row.transAmount }}</span>
                </template>
              </el-table-column>
              <el-table-column label="交易类型" align="center" prop="交易类型">
                <template slot-scope="scope">
                  <!-- <span>{{ scope.row.transType }}</span> -->
                  <span v-if="scope.row.transType == 'consume'">消费</span>
                  <span v-if="scope.row.transType == 'repay'">挂账还款</span>
                </template>
              </el-table-column>
              <!-- <el-table-column label="业务单号" align="center"  prop="业务单号" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.billNo }}</span>
                        </template>
                    </el-table-column> -->
              <!-- <el-table-column label="订单号" align="center"  prop="订单号" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.orderNumber }}</span>
                        </template>
                    </el-table-column> -->

              <el-table-column label="交易时间" align="center" prop="交易时间">
                <template slot-scope="scope">
                  <span>{{ scope.row.transDt }}</span>
                </template>
              </el-table-column>
              <el-table-column label="减免金额" align="center" prop="减免金额">
                <template slot-scope="scope">
                  <span>{{ scope.row.reductionAmount }}</span>
                </template>
              </el-table-column>
              <el-table-column
                label="剩余挂帐金额"
                align="center"
                prop="剩余挂帐金额"
              >
                <template slot-scope="scope">
                  <span>{{ scope.row.remainChargeAmount }}</span>
                </template>
              </el-table-column>
              <el-table-column label="结账方式" align="center" prop="结账方式">
                <template slot-scope="scope">
                  <!-- <span>{{ scope.row.exchangeType }}</span> -->
                  <span v-if="scope.row.exchangeType == 'cashier'">现金</span>
                  <span v-if="scope.row.exchangeType == 'charge'">挂账</span>

                  <span v-if="scope.row.exchangeType == 'wechat'"
                    >微信还款</span
                  >

                  <span v-if="scope.row.exchangeType == 'alipay'"
                    >支付宝还款</span
                  >
                </template>
              </el-table-column>
              <!-- <el-table-column label="交易终端" align="center"  prop="交易终端" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.client }}</span>
                        </template>
                    </el-table-column> -->
              <el-table-column label="操作人" align="center" prop="操作人">
                <template slot-scope="scope">
                  <span>{{ scope.row.oper }}</span>
                </template>
              </el-table-column>
              <!-- <el-table-column label="操作人登录名" align="center"  prop="操作人登录名" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.operLoginName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="还款模式" align="center"  prop="还款模式" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.repayType }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="店铺编码" align="center"  prop="店铺编码" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.merchantCode }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="店铺名称" align="center"  prop="店铺名称" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.merchantName }}</span>
                        </template>
                    </el-table-column>
                    <el-table-column label="挂帐人编码" align="center"  prop="挂帐人编码" >
                        <template slot-scope="scope">
                            <span>{{ scope.row.chargeMemberCode }}</span>
                        </template>
                    </el-table-column> -->

              <el-table-column
                label="操作"
                align="center"
                class-name="small-padding fixed-width"
              >
                <template slot-scope="scope">
                  <el-button
                    style="padding:0;"
                    type="text"
                    size="mini"
                    @click="openDialogDetail(scope.row.id)"
                    >详情</el-button
                  >
                  <!-- <el-button
                    style="padding:0;"
                    type="text"
                    size="mini"
                    @click="exportOrderInfoXls(scope.row.orderNumber)"
                    >导出</el-button
                  > -->
                  <!-- <el-tooltip
                    class="item"
                    effect="dark"
                    content="编辑"
                    placement="bottom"
                  >
                    <i
                      class="el-icon-edit textblue f16"
                      @click="gotoDetail(scope.row.id, scope.row.userCode)"
                    ></i>
                  </el-tooltip>
                  <el-tooltip
                    class="item"
                    effect="dark"
                    content="删除"
                    placement="bottom"
                  >
                    <i
                      class="el-icon-delete textblue f16 ml20"
                      @click="del(scope.row.id)"
                    ></i>
                  </el-tooltip> -->
                </template>
              </el-table-column>
            </el-table>
          </el-row></el-scrollbar
        >
      </div>
      <div class="footerBox">
        <!-- 分页区域 -->
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page.sync="queryInfo.currPage"
          :page-sizes="[10, 20, 30, 50]"
          :page-size="queryInfo.pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          :total="total"
        ></el-pagination>
      </div>
    </el-card>
    <!-- 明细弹窗 -->
    <el-dialog title="明细" :visible.sync="dialogDetails" width="1000px">
      <div>
        <el-table
          :data="detailsData"
          style="width:100%"
          border
          fit
          :height="height"
          highlight-current-row
          @sort-change="sortChange"
        >
          <el-table-column label="订单号" align="center" prop="orderNumber">
            <template slot-scope="scope">
              <span>{{ scope.row.orderNumber }}</span>
            </template>
          </el-table-column>
          <el-table-column label="商品类别" align="center" prop="categoryName">
            <template slot-scope="scope">
              <span>{{ scope.row.categoryName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="商品名称" align="center" prop="date">
            <template slot-scope="scope">
              <span>{{ scope.row.productName }}</span>
            </template>
          </el-table-column>
          <el-table-column label="单价" align="center" prop="date">
            <template slot-scope="scope">
              <span>{{ scope.row.productPrice }}</span>
            </template>
          </el-table-column>
          <el-table-column label="购买数量" align="center" prop="date">
            <template slot-scope="scope">
              <span>{{ scope.row.num }}</span>
            </template>
          </el-table-column>
          <el-table-column label="退货数量" align="center" prop="date">
            <template slot-scope="scope">
              <span>{{ scope.row.returnNum }}</span>
            </template>
          </el-table-column>
          <el-table-column label="点单时间" align="center" prop="orderTime">
            <template slot-scope="scope">
              <span>{{ scope.row.orderTime | dataFormat }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
      <span slot="footer" class="dialog-footer ">
        <el-button @click="dialogDetails = false">取消</el-button>
        <el-button @click="dialogDetails = false" type="primary"
          >确 定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
export default {
  data() {
    return {
      height: window.innerHeight - 256, //表格高度
      value: "",
      searchInput: "",
      tableData: [],
      loading: true,
      // 获取用户列表查询参数对象
      queryInfo: {
        // 当前页数
        currPage: 1,
        // 每页显示多少数据
        pageSize: 20,
        //查询条件
        condition: {
          id: "",
          startDt: ""
        }
      },
      userlist: [],
      total: 0,
      // 添加用户对话框
      addDialogVisible: false,
      // 用户添加
      addUserForm: {
        username: "",
        password: "",
        email: "",
        mobile: ""
      },
      // 修改用户
      editDialogVisible: false,
      editUserForm: {},
      // 分配角色对话框
      setRoleDialogVisible: false,
      charge: 0,
      remaing: 0,
      reductionAmount: 0,
      dialogDetails: false,
      detailsData: [],
      dateRange: ""
    };
  },
  created() {
    this.queryInfo.currPage = this.$route.query.currPage;
    this.queryInfo.pageSize = this.$route.query.pageSize;
    this.getListData();
    window.addEventListener("resize", this.getHeight);
  },
  mounted() {
    this.loading = false;
  },
  destroyed() {
    window.removeEventListener("resize", this.getHeight);
  },
  methods: {
    //条件查询
    search() {
      this.queryInfo.condition.chargeMemberName = this.searchInput;
      if (this.dateRange != null && this.dateRange != "") {
        var arr = [];
        arr = this.dateRange.toString().split(",");
        this.queryInfo.condition.startDt = arr[0];
        this.queryInfo.condition.endDt = arr[1];
      } else {
        this.queryInfo.condition.startDt = "";
        this.queryInfo.condition.endDt = null;
      }

      this.getListData();
    },
    repaySearch(value) {
      this.queryInfo.condition.transType = value;
      this.getListData();
    },
    // 监听 pagesize改变的事件
    handleSizeChange(newSize) {
      this.queryInfo.pageSize = newSize;
      this.getListData();
    },
    // 监听 页码值 改变事件
    handleCurrentChange(newSize) {
      this.queryInfo.currPage = newSize;
      this.getListData();
    },

    // 监听排序
    sortChange() {},
    //跳转到详情
    gotoDetail(id) {
      var that = this;
      this.$router.push({
        path: "/merchantChargeDetails/details",
        query: {
          id: id,
          currPage: that.queryInfo.currPage,
          pageSize: that.queryInfo.pageSize
        }
      });
    },

    // 删除用户
    async del(id) {
      const confirmResult = await this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      }).catch(err => err);
      if (confirmResult === "confirm") {
        var that = this;
        that.$http
          .post("/merchantChargeDetails/delete", { id: id })
          .then(function(response) {
            that.$notify.success({
              title: "提示",
              message: "删除成功",
              showClose: true
            });
            that.getListData();
          });
      }
    },
    getListData() {
      // 获取列表
      var that = this;
      that.queryInfo.condition.merchantCode = localStorage.getItem(
        "merchantCode"
      );
      that.$http
        .post("/merchantChargeDetails/list", that.queryInfo)
        .then(function(response) {
          console.log(response.data.data);
          if (response.data.code == 200) {
            that.total = response.data.data.pager.count;
            that.queryInfo.currPage = response.data.data.pager.currPage;
            that.tableData = response.data.data.pager.data;
            that.charge = response.data.data.charge;
            that.remaing = response.data.data.remaing;
            that.reductionAmount = response.data.data.reductionAmount;
          }
        });
    },
    // 监听表格高度
    getHeight() {
      this.height = window.innerHeight - 256;
    },
    openDialogDetail(id) {
      this.dialogDetails = true;
      this.id = id;
      this.getDetailsData();
    },
    getDetailsData() {
      var that = this;
      let data = {};
      data.id = this.id;
      that.$http
        .post("/merchantChargeDetails/queryOrderList", data)
        .then(response => {
          console.log("明细-----", response.data);
          if (response.data.code == 200) {
            that.detailsData = response.data.data;
          }
        });
    },
    exportXls() {
      var that = this;
      let data = {};
      data.merchantCode = localStorage.getItem("merchantCode");
      data.chargeMemberName = this.searchInput
      if(this.dateRange!=null && this.dateRange.length!=0){
        data.startDt=this.dateRange[0]
        data.endDt=this.dateRange[1]
      }else{
        data.startDt=null
        data.endDt=null
      }
      that.$http
        .post("merchantChargeDetails/exportXls", data)
        .then(response => {
          console.log("明细-----", response.data);
          if (response.data.code == 200) {
            // window.open(response.data.data);
            var a = document.createElement("a");
            a.href = response.data.data;
            a.download = response.data.data;
            a.style.display = "none";
            document.body.appendChild(a);
            a.click();
            a.remove();
            that.$message.success("导出成功");
          }
        });
    },
    exportOrderInfoXls(orderNumber) {
      var that = this;
      let data = {};
      data.orderNumber = orderNumber;
      that.$http
        .post("/merchantMemberConsumeRecord/exportOrderInfoXls", data)
        .then(response => {
          if (response.data.code == 200) {
            var a = document.createElement("a");
            a.href = response.data.data;
            a.download = response.data.data;
            a.style.display = "none";
            document.body.appendChild(a);
            a.click();
            a.remove();
            that.$message.success("导出成功");
          }
        });
    }
  }
};
</script>

<style lang="less" scoped>
.textblue {
  color: #008eff;
}
.managingPeople {
  .el-card {
    height: calc(100vh - 114px);
    position: relative;
    .el-select > .el-input {
      width: 200px;
    }
    .header-search-box .header-search-input {
      width: 325px;
    }
    input::placeholder {
      font-size: 12px;
    }
    .handle-btn .el-button.add-column-btn {
      width: 100%;
      font-size: 13px;
      background-color: transparent;
      color: #008eff;
      z-index: 102;
    }
    .footerBox {
      position: absolute;
      width: 100%;
      height: 78px;
      left: 20px;
      right: 20px;
      bottom: 0;
    }
    .row {
      margin-top: 30px;
    }
    .button {
      width: 300px;
      height: 80px;
    }
  }
}
/deep/.el-scrollbar__view {
  min-width: 100%;
}
/deep/.el-scrollbar__wrap {
  overflow-x: auto;
  height: calc(100%); //多出来的20px是横向滚动条默认的样式
  width: 100%;
}
/deep/.el-scrollbar .el-scrollbar__wrap .el-scrollbar__view {
  white-space: nowrap;
  display: inline-block;
}
/deep/ .el-button--primary {
  border: none;
}
/deep/ .el-range-editor--small .el-range__close-icon,
.el-range-editor--small .el-range__icon {
  line-height: 24px;
}
</style>
